/** THIS IS AN AUTO GENERATED FILE, DO NOT EDIT MANUALLY -- Created by @graphql-codegen */
import * as Types from '../../shared/generated.types'

import { api } from '../../utils'
export const AvailabilityResponseFragment = `
    fragment AvailabilityResponseFragment on AvailabilityResponse {
  providerIsAvailable
  patientIsAvailable
}
    `
export const AuditEntryFragment = `
    fragment AuditEntryFragment on AuditEntry {
  date
  reference {
    id
    type
    display
  }
}
    `
export const FileFragment = `
    fragment FileFragment on File {
  mimeType
  name
  url
}
    `
export const EmploymentFragment = `
    fragment EmploymentFragment on Employment {
  _id
  type
  status
  title
  role
  hireDate
  startDate
  terminationDate
  profession
  legalSex
  stateOfResidence
  onboardingCompleteDate
}
    `
export const ProviderIdentifierFragment = `
    fragment ProviderIdentifierFragment on ProviderIdentifier {
  id
  type
  value
  createdDate
  lastModified
}
    `
export const PractMgrReferenceFragment = `
    fragment PractMgrReferenceFragment on Reference {
  id
  display
}
    `
export const ExpectedHoursFragment = `
    fragment ExpectedHoursFragment on ExpectedHours {
  weeklyMinutesTotal
  serviceCategory {
    code
  }
  startDate
  endDate
}
    `
export const PayerSummaryFrag = `
    fragment PayerSummaryFrag on Payer {
  id
  name
  stateCode
  status
}
    `
export const PushSyncDocument = `
    mutation pushSync($appointmentIds: [String!]!) {
  pushSync(appointmentIds: $appointmentIds) {
    results {
      appointmentId
      status
    }
  }
}
    `
export const PullSyncDocument = `
    mutation pullSync($providerId: String!, $startDate: AWSDateTime!, $endDate: AWSDateTime!) {
  pullSync(providerId: $providerId, startDate: $startDate, endDate: $endDate) {
    results {
      appointmentId
      status
    }
  }
}
    `
export const CheckEmrAvailabilityDocument = `
    query checkEmrAvailability($content: AvailabilityRequest) {
  checkEmrAvailability(content: $content) {
    ...AvailabilityResponseFragment
  }
}
    ${AvailabilityResponseFragment}`
export const GetSyncHistoryDocument = `
    query getSyncHistory($providerId: String!) {
  getSyncHistory(providerId: $providerId) {
    id
    applicationName
    direction
    dateTime
    providerId
    appointmentId
    programId
    action
    appointmentDate
    status
    message
    nextgen {
      appointmentId
      providerId
      resourceId
      personId
    }
  }
}
    `

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    pushSync: build.mutation<Types.PushSync, Types.PushSyncVariables>({
      query: (variables) => ({ document: PushSyncDocument, variables }),
    }),
    pullSync: build.mutation<Types.PullSync, Types.PullSyncVariables>({
      query: (variables) => ({ document: PullSyncDocument, variables }),
    }),
    checkEmrAvailability: build.query<
      Types.CheckEmrAvailability,
      Types.CheckEmrAvailabilityVariables | void
    >({
      query: (variables) => ({
        document: CheckEmrAvailabilityDocument,
        variables,
      }),
    }),
    getSyncHistory: build.query<
      Types.GetSyncHistory,
      Types.GetSyncHistoryVariables
    >({
      query: (variables) => ({ document: GetSyncHistoryDocument, variables }),
    }),
  }),
})

export { injectedRtkApi as api }
